import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  bulkInventoryBinService,
  type CompleteBulkDisposeRequest,
  type CompleteBulkDisposeResponse,
} from '@/services/propertyBook/BulkInventoryBinService';
import { queryKeys } from '@/lib/queryKeys';

export const useCompleteBulkDispose = () => {
  const queryClient = useQueryClient();

  return useMutation<CompleteBulkDisposeResponse, unknown, CompleteBulkDisposeRequest>({
    mutationFn: (payload) => bulkInventoryBinService.completeDisposal(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.bulkInventoryBin.all });
      void queryClient.invalidateQueries({ queryKey: queryKeys.entities.lists() });
      void queryClient.invalidateQueries({ queryKey: ['transaction-log'] });
      void queryClient.invalidateQueries({ queryKey: ['exchange-replacement-options'] });
      void queryClient.invalidateQueries({ queryKey: ['asset-inventory'] });
    },
  });
};
